export default function sortRectsByTopLeft(rects: DOMRect[]): DOMRect[] {
  return rects.sort((rectA, rectB) => {
    const topDelta = rectA.top - rectB.top;
    if (topDelta !== 0) {
      return topDelta;
    }
    return rectA.left - rectB.left;
  });
}
